import { render, staticRenderFns } from "./AllPolls.vue?vue&type=template&id=913a4f58&"
import script from "./AllPolls.vue?vue&type=script&lang=js&"
export * from "./AllPolls.vue?vue&type=script&lang=js&"
import style0 from "./AllPolls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports